import TaskTypes from 'src/enums/TaskTypes';
import TaskSubTypes from 'src/enums/TaskSubTypes';
import { trackStatusToIntlMap, taskTypeToIntlMap, taskCategoryToIntlMap } from 'src/maps/tasks';
export var initialFilterTasks = {
    category: [taskCategoryToIntlMap.mandatory, taskCategoryToIntlMap.recommended],
    type: [
        taskTypeToIntlMap[TaskTypes.WATCH_VIDEO],
        taskTypeToIntlMap[TaskTypes.OPERATIONAL],
        taskTypeToIntlMap[TaskTypes.GOVERNANCE],
    ],
    status: [
        trackStatusToIntlMap.notStarted,
        trackStatusToIntlMap.inProgress,
        trackStatusToIntlMap.completed,
        trackStatusToIntlMap.planned,
        trackStatusToIntlMap.overdue,
        trackStatusToIntlMap.canceled,
    ],
    taskSubType: Object.values(TaskSubTypes),
    search: '',
};
export var defaultCheckedTasks = {
    category: [taskCategoryToIntlMap.mandatory, taskCategoryToIntlMap.recommended],
    type: [
        taskTypeToIntlMap[TaskTypes.WATCH_VIDEO],
        taskTypeToIntlMap[TaskTypes.OPERATIONAL],
        taskTypeToIntlMap[TaskTypes.GOVERNANCE],
    ],
    status: [
        trackStatusToIntlMap.notStarted,
        trackStatusToIntlMap.planned,
        trackStatusToIntlMap.inProgress,
        trackStatusToIntlMap.overdue,
    ],
    taskSubType: Object.values(TaskSubTypes),
    search: '',
};
export var editorList = [
    { url: 'effects', anchorText: 'add-chapters-effects', icon: 'exposure' },
    { url: 'manuscript', anchorText: 'add-manuscript-transcript', icon: 'toc' },
    { url: 'quick-guide', anchorText: 'quick-guide', icon: 'batch_prediction' },
    { url: 'links', anchorText: 'add-links', icon: 'link' },
    { url: 'voice-over', anchorText: 'voice-over', icon: 'mic_none' },
    { url: 'upload-files', anchorText: 'upload-files', icon: 'cloud_upload' },
];
export var translatorList = [
    { url: 'title', anchorText: 'translate-title-description', icon: 'title' },
    { url: 'effects', anchorText: 'effects', icon: 'exposure' },
    { url: 'manuscript', anchorText: 'manuscript-subtitles', icon: 'toc' },
    { url: 'quick-guide', anchorText: 'quick-guide', icon: 'batch_prediction' },
    { url: 'links', anchorText: 'add-links', icon: 'link' },
    { url: 'voice-annotation', anchorText: 'voice-over', icon: 'mic_none' },
    { url: 'upload-files', anchorText: 'upload-files', icon: 'cloud_upload' },
];
export var MINIMUM_CHAPTER_LENGTH = 200;
// For this list we only show the list of languages that are supported by polly
export var TRAININGTUBE_SUPPORTED_LANGUAGES = [
    'en-us',
    'da',
    'sv',
    'no',
    'fi',
    'de',
    'zh',
    'ar',
    'nl',
    'fr-fr',
    'it',
    'hi',
    'ja',
    'ko',
    'pl',
    'pt-pt',
    'ru',
    'ro',
    'es-es',
    'es-mx',
    'tr',
    'is',
    'cy',
    'fr-ca',
    'en-in',
    'en-gb',
    'en-cy',
];
// This is the maximum depth of the playlist tree
export var MAXIMUM_TRACK_DEPTH = 7;



//////////////////
// WEBPACK FOOTER
// ./src/utils/constants.ts
// module id = 764
// module chunks = 81